import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GlobalSearch, Image, Button } from 'Components/';
import BureauVeritasLogo from 'assets/bv-logo-sm.svg';
import history from 'src/history';
import NavMobileAction from './NavMobileAction/NavMobileAction';
import NavMobileProfileMenu from './NavMobileProfileMenu/NavMobileProfileMenu';
import NavMobileMainMenu from './NavMobileMainMenu/NavMobileMainMenu';
import './NavMobile.css';

class NavMobile extends Component {
  constructor(props) {
    super(props);

    this.handleNavigation = this.handleNavigation.bind(this);
    this.handleActiveMenuChange = this.handleActiveMenuChange.bind(this);
  }

  handleNavigation(e, link) {
    e.preventDefault();
    history.push(link);
    this.props.setNavState({ mobileActiveMenu: null });
  }

  handleActiveMenuChange(e, menu) {
    e.preventDefault();
    const { mobileActiveMenu, setNavState } = this.props;
    const value = mobileActiveMenu === menu ? null : menu;
    setNavState({ mobileActiveMenu: value });
  }

  render() {
    const { mobileActiveMenu } = this.props;

    return (
      <div className="nav-mobile">
        <div className="nav-mobile__container">
          <NavMobileAction
            active={mobileActiveMenu === 'menu'}
            onClick={e => this.handleActiveMenuChange(e, 'menu')}
            icon="menu"
          />
          <div className="nav-mobile__vr" />
          <Button
            onClick={() => {
              this.props.setNavState({ mobileActiveMenu: null });
              history.push('/');
            }}
            className="nav-mobile__logo"
          >
            <Image src={BureauVeritasLogo} alt="Bureau Veritas Logo" />
          </Button>

          <div className="nav-mobile__right">
            <NavMobileAction
              active={mobileActiveMenu === 'search'}
              onClick={e => this.handleActiveMenuChange(e, 'search')}
              icon="search"
            />
            <NavMobileAction
              active={mobileActiveMenu === 'profile'}
              onClick={e => this.handleActiveMenuChange(e, 'profile')}
              icon="person"
            />
          </div>
        </div>
        { mobileActiveMenu === 'search' && this.props.hasAcceptedTerms &&
          <GlobalSearch
            clients={this.props.clients.options}
            hasAccessToInvoices={this.props.userInfo.HasAccessToInvoices}
            isInternalUser={this.props.userInfo.IsInternalUser}
            handleClose={() => this.props.setNavState({ mobileActiveMenu: null })}
            submissionTypeOptions={this.props.submissionTypeOptions}
            clientNumber={this.props.clientNumber}
          />
        }
        { mobileActiveMenu === 'menu' && this.props.hasAcceptedTerms &&
          <NavMobileMainMenu
            filterFields={this.props.filterFields}
            filterFieldValue={this.props.filterFieldValue}
            filterItems={this.props.filterItems}
            filterItemValue={this.props.filterItemValue}
            filterPinnedItems={this.props.filterPinnedItems}
            togglePin={this.props.togglePin}
            clientNumber={this.props.clientNumber}
            clients={this.props.clients}
            setNavState={this.props.setNavState}
            viewMore={this.props.viewMore}
            userInfo={this.props.userInfo}
          />
        }
        { mobileActiveMenu === 'profile' && this.props.hasAcceptedTerms &&
          <NavMobileProfileMenu
            UserName={this.props.userInfo.UserName}
            Region={this.props.userInfo.Region}
            onNavigate={this.handleNavigation}
            handleLogout={this.props.handleLogout}
            hasManageAccess={this.props.hasManageAccess}
            hasLoginAsAdmin={this.props.hasLoginAsAdmin}
          />
        }
      </div>
    );
  }
}

const propTypeOptions = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string,
});

NavMobile.propTypes = {
  viewMore: PropTypes.bool,
  mobileActiveMenu: PropTypes.oneOf(['search', 'menu', 'profile']),
  setNavState: PropTypes.func,
  userInfo: PropTypes.shape({
    UserName: PropTypes.string,
    LOB: PropTypes.string,
    Region: PropTypes.string,
    HasAccessToInvoices: PropTypes.bool,
    IsInternalUser: PropTypes.bool,
  }),
  submissionTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    options: PropTypes.string,
    value: PropTypes.number,
  })),
  togglePin: PropTypes.func,
  handleLogout: PropTypes.func,
  clientNumber: PropTypes.string,
  clients: PropTypes.shape({
    options: PropTypes.arrayOf(propTypeOptions),
  }),
  filterItemValue: PropTypes.string,
  filterItems: PropTypes.shape({
    options: PropTypes.arrayOf(propTypeOptions),
  }),
  filterPinnedItems: PropTypes.shape({}),
  filterFieldValue: PropTypes.string,
  filterFields: PropTypes.shape({
    isLoading: PropTypes.bool,
    options: PropTypes.arrayOf(propTypeOptions),
  }),
  hasAcceptedTerms: PropTypes.bool,
  hasManageAccess: PropTypes.bool,
  hasLoginAsAdmin: PropTypes.bool,
};

export default NavMobile;



// WEBPACK FOOTER //
// ./src/containers/Nav/NavMobile/NavMobile.jsx